import React from 'react';
import PropTypes from 'prop-types';
import DefaultTextField from 'components/Utils/DefaultTextField';
import PerformanceUtils from 'services/PerformanceUtils';
import SearchAddress from './../SearchAddress';
import './style.scss';
import DefaultPatientTextField from 'components/Utils/DefaultPatientTextField';

const AddressFields = (props) => (
  <div className="row address-fields" style={{ width: '100%' }}>
    {!!props.onSearchResult && (
      <SearchAddress
        onSuccess={props.onSearchResult}
        className={props.className}
        style={props.style}
      />
    )}
    <Field className="large-address-field" label="Line 1" name="line1" {...props} />
    <Field className="large-address-field" label="Line 2" name="line2" {...props} />
    <Field name="postcode" {...props} />
    <Field name="city" {...props} />
    <Field name="state" {...props} />
    <Field name="country" {...props} />
    <Field name="notes" {...props} hide={props.showNotes !== true} />
    {props.includeLatLng === true && (
      <>
        <Field
          {...props}
          name="latitude"
          style={{ width: '49%', marginRight: '2%' }}
          className="latlng-field"
        />
        <Field {...props} name="longitude" style={{ width: '49%' }} className="latlng-field" />
      </>
    )}
  </div>
);

const Field = ({
  onChange,
  label,
  name,
  address,
  className = 'small-address-field',
  hide = false,
  isPatient = false,
  ...props
}) =>
  hide ? null : isPatient ? (
    <DefaultPatientTextField
      className={className}
      label={label ? label : PerformanceUtils.capitalizeFirstLetter(name)}
      name={name}
      onChange={onChange}
      disabled={onChange === undefined}
      value={address ? address[name] || '' : ''}
      {...props}
    />
  ) : (
    <DefaultTextField
      className={className}
      label={label ? label : PerformanceUtils.capitalizeFirstLetter(name)}
      name={name}
      onChange={onChange}
      disabled={onChange === undefined}
      value={address ? address[name] || '' : ''}
      {...props}
    />
  );

AddressFields.propTypes = {
  address: PropTypes.object,
  onChange: PropTypes.func,
  style: PropTypes.object,
  showNotes: PropTypes.bool,
  onSearchResult: PropTypes.func,
  includeLatLng: PropTypes.bool,
};

export default AddressFields;
